





















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { AnswerType } from '@/models/api/common/StudyResultTypes.vue'
import 'katex/dist/katex.min.css'
import katex from 'katex'

@Component
export default class StudyResultAnswers extends Vue {
  @Prop()
  answers!: AnswerType[]

  private get symStyle(): any {
    return function (sym: string, isAll: boolean) {
      let syles = {
        '--sym-color': sym === '採点中' ? 'var(--color-red)' : 'var(--color-black)',
      }
      if (isAll) syles['--border-type'] = 'solid'
      return syles
    }
  }

  private get rowStyle(): any {
    return function (questionNumber: number, questionCount: number) {
      return {
        '--border-type': questionNumber == questionCount ? 'solid' : 'dashed',
      }
    }
  }

  private get covertLatexAnswer(): any {
    return function (isLatex: boolean, answer: string) {
      return isLatex ? katex.renderToString(answer) : answer
    }
  }
}
